import moment from 'moment';

export const setCookie = (name, value, days) => {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const DaysSwitcher = (dayIndex) => {
  const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
  return days[dayIndex];
};

export const MonthSwitcher = (monthIndex) => {
  const months = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
  ];
  return months[monthIndex];
};

export const formatPhoneNumber = (phone) => {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11 && cleaned.startsWith('7')) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9, 11)}`;
  }
  return phone;
};

export function getCorrectWordForm(number, forms) {
  // Функция склонения слов
  const absNumber = Math.abs(number) % 100;
  const lastDigit = absNumber % 10;
  
  if (number > 10 && number < 20) {
    return `${number} ${forms[2]}`; // Например: 11, 12, 13 договоров
  }
  
  if (lastDigit > 1 && lastDigit < 5) {
    return `${number} ${forms[1]}`; // Например: 2, 3, 4 договора
  }
  
  if (lastDigit == 1) {
    return `${number} ${forms[0]}`; // Например: 1 договор
  }
  
  return `${number} ${forms[2]}`; // Например: 5, 6, 7 договоров
}

export function getFormattedCity(cityName) {
  // Именительный падеж:     [0]     'кто? что?',
  // Родительный падеж:      [1]     'кого? чего?',
  // Дательный падеж:        [2]     'кому? чему?',
  // Винительный падеж:      [3]     'кого? что?',
  // Творительный падеж:     [4]     'кем? чем?',
  // Предложный падеж:       [5]     'о ком? о чем?',

  switch (cityName) {
    case "Самара": return ["Самара", "Самары", "Самаре", "Самару", "Самарой", "Самаре"];
    case "Тольятти": return ["Тольятти", "Тольятти", "Тольятти", "Тольятти", "Тольятти", "Тольятти"];
    case "Пенза": return ["Пенза", "Пензы", "Пензе", "Пензу", "Пензой", "Пензе"];
    case "Димитровград": return ["Димитровград", "Димитровграда", "Димитровграду", "Димитровград", "Димитровградом", "Димитровграде",];
    case "Балаково": return ["Балаково", "Балаково", "Балаково", "Балаково", "Балаково", "Балаково"];
    case "Новокуйбышевск": return ["Новокуйбышевск", "Новокуйбышевска", "Новокуйбышевску", "Новокуйбышевск", "Новокуйбышевском", "Новокуйбышевске"];
    case "Саранск": return ["Саранск", "Саранска", "Саранску", "Саранск", "Саранском", "Саранске"];
    default: return [cityName, cityName, cityName, cityName, cityName, cityName];
  }
};

export const getOrderStatusName = (status) => {
  switch (status) {
    case 2: return 'В работе';
    case 10: return 'В работе';
    case 20: return 'Доставляется';
    case 100: return 'Отменен';
    case 50: return 'Завершен';
    case 131072: return 'Готовится';
    case 1048576: return 'Ожидает доставки';
    case 8388608: return 'Доставляется';
    case 67108864: return 'Доставлен';
    case 536870912: return 'Отменен';
    case 1073741824: return 'Завершен';
    default: return 'Уточняется';
  }
};

export function formatDateString(dateString) {
  const [year, month, day] = dateString.split('-');
  const months = [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
  ];
  return `${day} ${months[parseInt(month, 10) - 1]} ${year}`;
}

export const getMinutesUntil = (orderToValue) => {
  if (!orderToValue) {
    return 0;
  }
  const now = moment();
  const target = moment.unix(orderToValue);
  const diff = target.diff(now, 'minutes', true);
  return diff <= 0 ? 0 : Math.ceil(diff);
};
